import React, { useState } from 'react';
import clsx from 'clsx';
import { useExportDrivers } from '../../hooks/react-query/useDrivers';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/Popover';
import { Dialog, DialogContent, DialogTrigger } from '../ui/Modal';
import { ActionDotsBlack, SpinnerIcon } from '../../icons';
import AddEditDriver from './addEditDriver';

const DriverMobileViewTitle = ({ handleAddMultipleDrivers }) => {
  const { mutate: getExistingDrivers, isLoading } = useExportDrivers();

  const [openPopover, setOpenPopover] = useState(false);
  const [openFirstModal, setOpenFirstModal] = useState(false);

  const handleExportDrivers = () => {
    getExistingDrivers();
  };

  return (
    <div className="lg:hidden">
      <Popover
        open={openPopover}
        onOpenChange={(open) => {
          setOpenPopover(open);
        }}
      >
        <PopoverTrigger>
          <ActionDotsBlack
            className={
              openPopover
                ? 'bg-black stroke-white rounded-full'
                : 'stroke-black cursor-pointer'
            }
          />
        </PopoverTrigger>
        <PopoverContent>
          <ul className="flex flex-col gap-y-2.5 p-2.5">
            <li>
              <ActionButton
                title="Καταχώρηση Νέου Οδηγού"
                openModal={openFirstModal}
                setOpenModal={setOpenFirstModal}
              >
                <AddEditDriver
                  setOpenModal={() => setOpenFirstModal(false)}
                  handleAddMultipleDrivers={handleAddMultipleDrivers}
                />
              </ActionButton>
            </li>
            <li>
              <button
                type="button"
                className="flex items-center gap-x-2"
                onClick={handleExportDrivers}
              >
                {isLoading && <SpinnerIcon className="w-4 h-4" />}
                <span className="body-text">Εξαγωγή αρχείου</span>
              </button>
            </li>
          </ul>
        </PopoverContent>
      </Popover>
    </div>
  );
};

const ActionButton = ({
  title,
  children,
  className,
  openModal,
  setOpenModal,
}) => {
  return (
    <Dialog open={openModal} onOpenChange={(open) => setOpenModal(open)}>
      <DialogTrigger className={clsx('body-text', className)}>
        {title}
      </DialogTrigger>
      <DialogContent className="h-full">{children}</DialogContent>
    </Dialog>
  );
};

export default DriverMobileViewTitle;
